<template>
  <transition name="dialog">
    <div class="lbs-dialog-container"
         :style="style">
      <div class="lbs-dialog-header">
        <slot name="header">
          <h2>{{ title }}</h2>
        </slot>
        <button class="lbs-dialog-close-button"
                @click="$emit('close')"/>
      </div>

      <div class="lbs-dialog-body">
        <slot name="body">
          {{ message }}
        </slot>
      </div>

      <div class="lbs-dialog-footer">
        <slot name="footer">
          default footer
          <button class="lbs-button"
                  @click="$emit('close')">
            OK
          </button>
        </slot>
      </div>
    </div>
  </transition>
</template>

<script>
  import positionable from '../mixins/positionable-mixin';
  import draggable from '../mixins/draggable-mixin';

  const ENTER_KEY_CODE = 27;

  export default {
    mixins: [draggable, positionable],
    props: {
      title: {
        type: String,
        default: ''
      },
      message: {
        type: String,
        default: ''
      }
    },
    methods: {
      // Forces repaint; use sparingly
      centerDialog () {
        const parentDims = this.$el.parentNode.getBoundingClientRect();
        const selfDims = this.$el.getBoundingClientRect();
        this.moveTo({
          top: `${(parentDims.height - selfDims.height) / 2}px`,
          left: `${(parentDims.width - selfDims.width) / 2}px`
        });
      }
    },
    created () {
      const self = this;
      this._escapeKeyHandler = e => {
        if (e.keyCode === ENTER_KEY_CODE) {
          self.$emit('close');
        }
      };
      document.addEventListener('keydown', this._escapeKeyHandler);
    },
    mounted () {
      this.setDragTarget(this.$el.querySelector('.lbs-dialog-header'));
      this.centerDialog(); // default position
      this.restorePosition(); // restorePosition attempts to pull last position from local storage.
    },
    destroyed () {
      this.savePosition();
      document.removeEventListener('keydown', this._escapeKeyHandler);
    }
  };
</script>

<style lang="sass">
    // already imported - @import "./lbs-dialog.scss";
</style>



// WEBPACK FOOTER //
// src/uScope/js/components/vue/lbs-dialog.vue